module.exports = __webpack_public_path__ + "img/folder-code.07e8354c.svg";